
import { Modal, Tooltip } from '05-ui-kit';
import { ref } from '@vue/composition-api';
interface Props {
  /**
   * ID акции
   */
  id: string;

  /**
   * Название акции
   */
  title: string;

  /**
   * Нужен для формирования УРЛа на страницу акции
   */
  code: string;

  /**
   * Дата окончания акции
   */
  date?: string;

  /**
   * Изображение акции
   */
  image?: string;

  /**
   * Анонс акции
   */
  announcement?: string;
  /**
   * Реклама акции
   */
  advertising?: string;
}
const __sfc_main = {};
__sfc_main.props = {
  id: {
    key: "id",
    required: true,
    type: String
  },
  title: {
    key: "title",
    required: true,
    type: String
  },
  code: {
    key: "code",
    required: false,
    type: String,
    default: '#'
  },
  date: {
    key: "date",
    required: false,
    type: String
  },
  image: {
    key: "image",
    required: false,
    type: String
  },
  announcement: {
    key: "announcement",
    required: false,
    type: String
  },
  advertising: {
    key: "advertising",
    required: false,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const isAdvertising = ref(false);
  function onClick() {
    emit('click', {
      data: {
        code: props.code,
        name: props.title
      }
    });
  }
  return {
    isAdvertising,
    onClick
  };
};
__sfc_main.components = Object.assign({
  Tooltip,
  Modal
}, __sfc_main.components);
export default __sfc_main;
